export { default as IMAGE_ADEVINTA_LOGO } from '@move-core/asset-catalog/images/ca/web/img-logo-footer.svg';
export { default as FLAG_ICON } from '@move-core/asset-catalog/images/ca/web/img-flag.svg';
export { default as ANDROID_APP_STORE_IMAGE } from '@move-core/asset-catalog/images/ca/web/img-android-appstore.svg';
export { default as IOS_APP_STORE_IMAGE } from '@move-core/asset-catalog/images/ca/web/img-ios-appstore.svg';
export const DEFAULT_PUBLIC_DOMAIN_URL = 'https://www.kijijiautos.ca';
